import { ApiService } from './common/serviceBase';
import { URL_NOVA_API } from './common/apiUrl';

const service = new ApiService(`${URL_NOVA_API}`);

export async function getIntegracoes() {
    const response = await service.get(`/config/integracoes`);
    return response.data;
}

export async function putIntegracoes(data) {
    const response = await service.patch(`/config/integracoes`, data);
    return response;
}